﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function facilityInfoBlock(context) {

  function init() {
    const hiddenTextBlocks = document.querySelectorAll('.facilityinfoblock__right__text__expanded');
    const facilityInfoTextBlocks = document.querySelectorAll('.facilityinfoblock__right');
    const showMoreButtons = document.querySelectorAll('.facilityinfoblock__right__showmore');

    if (!hiddenTextBlocks) return

    hiddenTextBlocks.forEach((block, n) => {
      block.setAttribute('id', 'text' + n);
      if (showMoreButtons[n]) showMoreButtons[n].setAttribute('aria-controls', 'text' + n);
    })

    const showMore = (event) => {
      event.stopPropagation()
      const targetParent = event.target.closest('.facilityinfoblock')
      const target = targetParent.querySelector('.facilityinfoblock__right__text__expanded');
      const n = +target.id.substring(4);

      hiddenTextBlocks.forEach((block, i) => {
        if (i !== n) return
        targetParent.classList.toggle('facilityinfoblock--expanded');
        if (targetParent.classList.contains('facilityinfoblock--expanded')) {
          targetParent.querySelector('.facilityinfoblock__right__showmore').setAttribute('aria-expanded', 'true');
          target.setAttribute('aria-hidden', 'false');
        } else {
          targetParent.querySelector('.facilityinfoblock__right__showmore').setAttribute('aria-expanded', 'false');
          target.setAttribute('aria-hidden', 'true');
        }
      })
    }

    showMoreButtons.forEach(button => button.addEventListener('click', showMore))
    facilityInfoTextBlocks.forEach(block => block.querySelector('.facilityinfoblock__right__showmore') && block.addEventListener('click', showMore))
  }
  return {
    init
  };
}

controller.add('facility-info-block', facilityInfoBlock);